module.exports = __webpack_public_path__ + "media/images/ringrevenue/icon_printer-242421c98dbd8b054fc76a036d04321c.png";